// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 3 ? "build-glob" : chunkId) + "-legacy." + {"3":"8b920136","515":"0a6bc462","719":"cf71d981","725":"ec91f90d","729":"c43942ee","834":"8fcc8727"}[chunkId] + ".js";
};